var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressTruck(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#express-truck_svg__clip0_875_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.662 21a4.375 4.375 0 110-1.75h3.675a4.38 4.38 0 013.413-3.412V7H2.625a.875.875 0 010-1.75h14a.875.875 0 01.875.875V8.75H21A5.25 5.25 0 0126.25 14v6.125a.875.875 0 01-.875.875h-4.462a4.375 4.375 0 01-8.575 0H8.663zM17.5 10.5v5.338a4.38 4.38 0 013.413 3.412H24.5V14a3.5 3.5 0 00-3.5-3.5h-3.5zm-.875 12.25a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm-12.25 0a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm-3.5-14h5.25a.875.875 0 010 1.75H.875a.875.875 0 010-1.75zm1.75 3.5h5.25a.875.875 0 010 1.75h-5.25a.875.875 0 010-1.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "express-truck_svg__clip0_875_524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h26.25v28H0z"
  })))));
}

export default SvgExpressTruck;